
const columnList: Array<column> = [
    {
        prop: "name",
        label: "设置项",
        width: 355,
    },
    {
        prop: "value",
        label: "值",
        width: 355,
    },
    {
        prop: "desc",
        label: "值备注",
        width: 355,
    },
];
import {
    defineComponent,
    ref,
    reactive,
    inject,
    onMounted,
    watch,
    Ref,
} from "vue";
import { Request } from "@/api/request";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "Other",
    setup() {
        let tableData = ref([]),
            loading = ref(false),
            headClass = inject("headClass"),
            dialogVisible = ref(false),
            formRef = ref(null),
            form: Ref<any> = ref({} as any),
            getTableData = (): void => {
                loading.value = true;

                Request.axiosInstance({
                    url: "adminapi/Operate/otherUpList",
                }).then((res: any) => {
                    loading.value = false;
                    if (res.status == 200) {
                        tableData.value = res.content.list;
                        tableData.value.forEach((item: any, index) => {
                            form.value[index + 1] = item.value;
                        });
                    }
                });
            },
            onSubmit = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        let list: any = [];
                        tableData.value.forEach((item: any, index) => {
                            list.push({
                                    id: item.id,
                                    value: form.value[index + 1],
                                });
                        });
                        Request.axiosInstance({
                            url: "adminapi/Operate/otherSetup",
                            data: {
                                list,
                            },
                        }).then((res: any) => {
                            getTableData();
                            dialogVisible.value = false;
                        });
                    }
                });
            };
        onMounted(() => {
            getTableData();
        });
        return {
            columnList,
            headClass,
            loading,
            tableData,
            dialogVisible,
            formRef,
            form,
            onSubmit,
        };
    },
});
